import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { LDFlagSet } from 'launchdarkly-js-client-sdk';
import { FEATURE_FLAGS } from '@app/infrastructure/feature-flag-manager/feature-flag-list';
import { OrganizationTypes } from '@core/services/organization/organization.interface';
import { UserService } from '@app/services/user/user.service';
import { FeatureFlagManagerService } from '@app/infrastructure/feature-flag-manager/feature-flag-manager.service';
import { AppRouteHelper } from '@shared/helpers/app-route.helper';

@Injectable({
	providedIn: 'root',
})
export class AzureOrgGuard implements CanActivate {
	constructor(
		private router: Router,
		private userService: UserService,
		private featureFlagManager: FeatureFlagManagerService,
	) {}

	canActivate(
		route: ActivatedRouteSnapshot,
	): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
		return this.featureFlagManager.flags$.pipe(
			take(1),
			map((flags: LDFlagSet) => {
				const isEnabledOptHub = flags[FEATURE_FLAGS.ENABLE_OPTIMIZATION_HUB];
				const currOrg = this.userService.organization;
				const isAzureOrg = currOrg.org_cloud_type === OrganizationTypes.Azure;

				if (isEnabledOptHub && isAzureOrg) {
					return true;
				} else {
					const redirectPath = route.data.alternativePath ? route.data.alternativePath : AppRouteHelper.notFound;
					void this.router.navigate([redirectPath]);
					return false;
				}
			}),
		);
	}
}
